/**
 * Created by rak on 11/14/2014.
 */
'use strict';
angular.module('betosyswebapp').controller('passwordController', function ($scope, $rootScope, $uibModalInstance, $http, base64, AuthenticationService,$translate, errorCode) {
  $scope.credentials = {
    OldPassword: '',
    NewPassword: '',
    ConfirmPswrd: ''
  };
  $scope.alerts=[];
  var errorAlert=null;
  $scope.save = function () {
    $scope.alerts = [];
    if (($scope.credentials.OldPassword !== '' && $scope.credentials.NewPassword !== '' && $scope.credentials.ConfirmPswrd !== '')) {
      if (angular.equals($scope.credentials.NewPassword, $scope.credentials.ConfirmPswrd)) {
        AuthenticationService.changePassword($scope.credentials.OldPassword, $scope.credentials.NewPassword).then(function () {
          var successAlert = {type: 'success', msg: $translate.instant('passwordChange.success'), autoDismiss: true};
          $scope.alerts.push(successAlert);
          if(errorCode === 'PE0010') {
            $uibModalInstance.close($scope.credentials.NewPassword);
          }
        }, function (response) {
          if (response.data && response.data.errors && response.data.errors.length > 0) {
            angular.forEach(response.data.errors, function (value) {
              if (value.code === '60000') {
                $scope.alerts.push({type: 'error', msg: $translate.instant('passwordChange.accountmismatch'), autoDismiss: true});
              } else if (value.code === '60001') {
                $scope.alerts.push({type: 'error', msg: $translate.instant('passwordChange.oldpasswordwrong'), autoDismiss: true});
              } else {
                // No specific translation: Fall back to message
                errorAlert  = {type: 'error', msg: response.data.message, autoDismiss: true};
                $scope.alerts.push(errorAlert);
              }
            }); 
          } else if (response.data) {
            errorAlert  = {type: 'error', msg: response.data.message, autoDismiss: true};
            $scope.alerts.push(errorAlert);
          }
        });
      } else {
        errorAlert  = {type: 'error', msg: $translate.instant('passwordChange.mismatch'), autoDismiss: true};
        $scope.alerts.push(errorAlert);
      }
    }
    else {
      errorAlert = {type: 'error', msg:  $translate.instant('passwordChange.requiredField'), autoDismiss: true};
      $scope.alerts.push(errorAlert);
    }
  };

  $scope.close = function () {
    $uibModalInstance.dismiss('cancel');
  };
  $scope.onKeyPress = function ($event) {
    if ($event.keyCode === 13) {
      // Here is where I must fire the click event of the button
      $scope.save();
    }
  };

  $scope.closeAlertByIndex = function (index) {
    $scope.alerts.splice(index, 1);
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/login/passwordController.js